import { FormBuilder } from '@angular/forms';
import { VoiceProduct } from '@shared/models/voice-product.model';
import { SimService } from '../../services/sim.service';
import { SubscriptionService } from '../../services/subscription.service';
import { FormStateModel } from './form.types';
import { VerificationType } from '@app/sales/modules/details/constants/Verification';

export type VerificationPayload =
  | { type: VerificationType.physical }
  | { type: VerificationType.bankID }
  | { type: VerificationType.TwoFA; verificationCode: string };

export class FormResetAction {
  public static readonly type = '[Validation] Reset state';
}

export class TradeInFormResetAction {
  public static readonly type = '[FormState] Reset trade in form state';
}

export class ProductFormResetAction {
  public static readonly type = '[FormState] Reset product form state';
}

export class AddVoiceSubscriptionForMobilephoneToFormStateAction {
  public static readonly type = '[FormState] Add voice subscription for mobile phone to Form state';
  constructor(public voiceProduct: VoiceProduct) {}
}

export class AddVoiceSubscriptionForAccessoryToFormStateAction {
  public static readonly type = '[FormState] Add voice subscription for accessory to Form state';
  constructor(public voiceProduct: VoiceProduct) {}
}

export class ValidateMobileProductWithNewVoiceProductAction {
  public static readonly type = '[FormState] Validate and set mobile product status';
  constructor(
    public voiceProductId: string,
    public mobileProductId: string
  ) {}
}

export class UpdateVoiceFormValidStatusAction {
  public static readonly type = '[FormState] Set voice valid form state';
  constructor(
    public products: VoiceProduct[],
    public formState: FormStateModel,
    public formBuilder: FormBuilder,
    public simService: SimService,
    public subscriptionService: SubscriptionService,
    public resetSubscriptionForm?: boolean
  ) {}
}

export class UpdateMbbFormValidStatusAction {
  public static readonly type = '[FormState] Set mbb valid form state ';
  constructor(
    public formState: FormStateModel,
    public formBuilder: FormBuilder,
    public simService: SimService,
    public resetMbbForm = false
  ) {}
}

export class UpdateFormHasBeenInView {
  public static readonly type = '[FormState] Update form has been in view';
  constructor(public path: string) {}
}

export class UpdateCustomerValidationFormAction {
  static readonly type = '[Form] Update Customer Validation Form';
  constructor(public payload: VerificationPayload) {}
}

export class UpdateCustomerAllowanceFormAction {
  static readonly type = '[Form] Update Customer Allowance Form';
  constructor(
    public firstName: string,
    public lastName: string,
    public ssn: string
  ) {}
}
